import React from 'react'
import Tabs from '../Components/Tabs'

export default function Services() {
    return (
        <Tabs />
    )
}
